import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import BaseMenu from '../36fafb8b08bebf903e007ac5e11aa186050a627ca8ec465b9aa45b6f4a80c9da.cfe-internal.js';

var _excluded = ["selectable", "defaultLabel", "defaultValue", "selectedValue", "onSelectedValueChange", "unstable_isMultiSelect", "isMultiSelect"];
var Menu = /*#__PURE__*/React__default.forwardRef(function Menu(_ref, ref) {
  var selectable = _ref.selectable,
    defaultLabel = _ref.defaultLabel,
    defaultValue = _ref.defaultValue,
    externalSelectedValue = _ref.selectedValue,
    onSelectedValueChange = _ref.onSelectedValueChange,
    unstable_isMultiSelect = _ref.unstable_isMultiSelect,
    isMultiSelect = _ref.isMultiSelect,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(BaseMenu, _extends({
    ref: ref,
    menuType: Menu
  }, rest));
});

export { Menu as default };
